import PropTypes from 'prop-types'
import SiteView from 'components/admin/Interventions/SiteView'
import TierLabel from 'components/TierLabel'
import { EXPORT_BUTTON_UPDATE_FLAG, isFlagOn } from 'utils/featureFlags'
import { TOOLTIP_LOCATIONS, TOOLTIP_PROGRAMS } from 'utils/tooltipHelpers'
import {
  HeaderContent,
  K8Tier2ViewContainer,
  LastUpdatedAtText,
  LeftBox,
  LoadingMessage,
  RightBox,
  SiteHeader,
  StyledAdminExportDownloadButton,
  StyledInterventionsSubheader,
  TierPill,
  Title,
  TitleWrapper,
} from './component.styles'
import { HEADER_TEXT, LOADING_TEXT, TIER_2_LABEL_TEXT } from './constants'

const AdminK8Tier2View = ({ summary, tier2DashboardSites, isFetching }) => {
  if (!Array.isArray(tier2DashboardSites) || tier2DashboardSites.length < 1) {
    return null
  }

  const site = tier2DashboardSites?.[0] || {}

  return (
    <K8Tier2ViewContainer key={site.siteId}>
      <SiteHeader>
        <HeaderContent>
          <LeftBox>
            <TitleWrapper>
              <Title>{HEADER_TEXT}</Title>
              <TierPill>
                <TierLabel labelText={TIER_2_LABEL_TEXT} />
              </TierPill>
            </TitleWrapper>
            <StyledInterventionsSubheader summary={summary} />
          </LeftBox>
          <RightBox>
            <LastUpdatedAtText>{summary.lastUpdatedAt}</LastUpdatedAtText>
            {isFlagOn([EXPORT_BUTTON_UPDATE_FLAG]) && (
              <StyledAdminExportDownloadButton
                buttonText="Your Report"
                programKey={TOOLTIP_PROGRAMS.K8_MONITOR}
                tooltipLocation={TOOLTIP_LOCATIONS.EXPORT_BUTTON}
              />
            )}
          </RightBox>
        </HeaderContent>
      </SiteHeader>
      <SiteView isSingleSite={true} site={site} />
      {isFetching && <LoadingMessage>{LOADING_TEXT}</LoadingMessage>}
    </K8Tier2ViewContainer>
  )
}

AdminK8Tier2View.propTypes = {
  isFetching: PropTypes.bool,
  summary: PropTypes.shape({
    groupsThatHaventCompletedLesson: PropTypes.number.isRequired,
    lessonsCompleted: PropTypes.number.isRequired,
    numberOfSites: PropTypes.number.isRequired,
    lastUpdatedAt: PropTypes.string,
    smallGroupsCreated: PropTypes.number.isRequired,
  }).isRequired,
  tier2DashboardSites: PropTypes.arrayOf(
    PropTypes.shape({
      gradeBandData: PropTypes.array,
      siteId: PropTypes.number.isRequired,
    }),
  ).isRequired,
}

export default AdminK8Tier2View
